export default __webpack_public_path__ + "media/discover.39074.png";